import { SettingListItem } from "services/KnowfullyAdminClient";
import { Box } from "@mui/material";
import { SettingTypeId } from "types/common-types";

const styles = {
  colorWrapper: {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "text-top",
  },
  colorCircle: {
    mr: 1,
    border: "1px solid lightgrey",
    borderRadius: "50%",
    width: "25px",
    height: "25px",
  },
};

type SettingValueProps = {
  value: SettingListItem;
};

export default function SettingValue({ value }: SettingValueProps) {
  if (value.settingTypeId === SettingTypeId.Color) {
    return (
      <Box sx={styles.colorWrapper}>
        <Box sx={{ ...styles.colorCircle, backgroundColor: value.value }} />
        <Box>{value.value}</Box>
      </Box>
    );
  }
  if (value.settingTypeId === SettingTypeId.Html) {
    return <i>{value.value && "<HTML />"}</i>;
  }

  return <>{value.value}</>;
}
